import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { LoadingSpinner, PageLayout } from "lib";
import { Helmet } from "react-helmet";
import { EventsAPI } from "api_inbusiness";
import { PrimaryButton } from "lib/components/Buttons/buttons";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import dayjs from "dayjs";
import { TicketsTable } from "./tickets-table";

export const VolunteerTicketsPage = () => {
  const { eventId } = useParams();
  const navigate = useHistory();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    EventsAPI.getById(eventId).then((res) => {
      if (res.ok) {
        setEvent(res.data);
      } else {
        console.error("Event not found");
      }
      setLoading(false);
    });
  }, [eventId]);

  const handleGoBack = () => {
    navigate.goBack();
  };

  if (loading) {
    return (
      <PageLayout title="Se încarcă...">
        <LoadingSpinner margin="5rem auto" loading={loading} />
      </PageLayout>
    );
  }

  if (!event) {
    return (
      <PageLayout title="Eroare">
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <h3>Evenimentul nu a fost găsit</h3>
          <PrimaryButton onClick={handleGoBack} startIcon={<ArrowBackIcon />}>
            Înapoi
          </PrimaryButton>
        </div>
      </PageLayout>
    );
  }

  const formatDate = (date) => {
    return dayjs(date).format("DD/MM/YYYY");
  };

  return (
    <>
      <Helmet>
        <title>InBusiness CRM :: Tichete - {event.title}</title>
      </Helmet>
      <PageLayout
        title={`Tichete - ${event.title}`}
        subtitle={`${event.county?.name || ""} ${event.location} • ${formatDate(
          event.date
        )}`}
        actionArea={
          <PrimaryButton onClick={handleGoBack} startIcon={<ArrowBackIcon />}>
            Înapoi la evenimente
          </PrimaryButton>
        }
      >
        <TicketsTable eventId={eventId} />
      </PageLayout>
    </>
  );
};
